import { Drawer, Stack } from '@mui/material';
import { useAtom } from 'jotai';
import { kpiPanelOpen, selectedWorkpackIdForKpiTracker } from '../../state';
import { KpiPanel } from './KpiPanel';
import { useNavbarHeight } from '@/hooks/useNavbarHeight';
import { useKpiWorkpackUrlSync } from '@/components/Analysis/Insights/deeplink';

const DRAWER_WIDTH = '60vw';

export const KpiPanelDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(kpiPanelOpen);
  const [workpackId, setWorkpackId] = useAtom(selectedWorkpackIdForKpiTracker);
  const navbarHeight = useNavbarHeight();

  useKpiWorkpackUrlSync(workpackId, setWorkpackId, isOpen, setIsOpen);

  const handleClose = () => setIsOpen(false);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleClose}
      PaperProps={{ sx: { width: DRAWER_WIDTH, backgroundColor: 'background.paper' } }}
      transitionDuration={300}
    >
      <Stack
        id="kpi-panel"
        sx={{ paddingTop: `${navbarHeight}px`, overflowY: 'auto', height: '100%' }}
      >
        <KpiPanel />
      </Stack>
    </Drawer>
  );
};
